var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_436_4940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_436_4940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8209 18.7913C16.0934 18.7913 14.3579 18.3897 12.6144 17.5864C10.8711 16.7831 9.26785 15.6499 7.80469 14.1869C6.3475 12.7238 5.21725 11.1219 4.41394 9.3813C3.61064 7.64085 3.20898 5.9069 3.20898 4.17945C3.20898 3.90445 3.30065 3.67375 3.48398 3.48736C3.66732 3.30113 3.89648 3.20801 4.17148 3.20801H7.16119C7.39265 3.20801 7.59684 3.28356 7.77376 3.43465C7.95067 3.5856 8.06319 3.77214 8.11132 3.99428L8.6368 6.69134C8.67316 6.94159 8.66552 7.15663 8.61388 7.33645C8.56209 7.51626 8.4692 7.66728 8.33521 7.78951L6.21817 9.8504C6.55887 10.4743 6.94814 11.0646 7.386 11.6212C7.82371 12.1776 8.29763 12.709 8.80775 13.2155C9.3107 13.7186 9.84542 14.1858 10.4119 14.6171C10.9784 15.0484 11.5901 15.4497 12.2471 15.8211L14.3041 13.7462C14.4475 13.597 14.6213 13.4923 14.8252 13.4323C15.029 13.3724 15.2408 13.3577 15.4607 13.3883L18.006 13.9067C18.2375 13.9678 18.4264 14.0859 18.5728 14.2609C18.7191 14.436 18.7923 14.6346 18.7923 14.8568V17.8288C18.7923 18.1038 18.6992 18.333 18.513 18.5163C18.3266 18.6997 18.0959 18.7913 17.8209 18.7913Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent1);
export default __webpack_public_path__ + "static/media/Component 1.3c6408c22e2cec96f9b2c0d157de24af.svg";
export { ForwardRef as ReactComponent };